<ng-container [formGroup]="group">
  <label for="input-instructor-name">Instructor Name</label>
  <div class="input-group">
    <span bsMigration class="input-group-addon"><fa-icon [icon]="faMagnifyingGlass"></fa-icon></span>
    <input type="text" class="form-control" id="input-instructor-name" placeholder="instructor name" required autocomplete="off"
      [typeaheadWaitMs]="300" [typeaheadMinLength]="3" [typeahead]="Instructors$" [typeaheadAsync]="true"
      typeaheadOptionField="ind_full_name_cp" [typeaheadItemTemplate]="item" formControlName="InstructorName"
      (typeaheadOnSelect)="InstructorOnSelect($event)">
  </div>
  <p class="help-block">Start typing a few letters to search our database. If not found, just enter your instructor's
    full
    name to the best of your ability.</p>
</ng-container>

<ng-template #item let-model="item" let-index="index">
  {{ model.ind_badge_name || model.ind_first_name }} {{ model.ind_last_name }}
</ng-template>
